const timelineData = [
    { year: 'Diyatharippu - 700 years ago', image: '/7 century.jpg' },
    { year: 'vidyodaya-pirivena - 1952', image: '/vidyodaya-pirivena.jpg' },
    { year: 'Eye Hospital Colombo - 1962', image: '/EyeHospitalColombo.jpg' },
    { year: 'Eye Care - 2007', image: '/2024.jpg' },
    { year: 'NVQ NCS Development - 2012', image: '/nvq.jpg' },
    { year: 'Sri Jayawardhanapura & SEGi University - 2022', image: '/uni.png' },
    { year: '1st International Optometric Conference in Sri Lanka - 2026', image: '/main banner.png' },
 
    // Add more data here as needed
  ];
  
  export default timelineData;
  